module.exports = __webpack_public_path__ + "img/branton-thermostats.d0231a8a.jpg";